'use client';

import DefaultErrorFallback from '@/components/internal/DefaultErrorFallback';

export default function Error() {
  return <DefaultErrorFallback />;
}
